import { middleware as analyticsMiddleware } from './analytics';
import { middlewares as customizationMiddlewares } from './customization';

export default {
  analyticsMiddleware,
  ...customizationMiddlewares
};
